import request from '@/router/axios';

let urlPrefix = '/api/lab/tasks';

/**
 * 新增课堂作业
 * @param {Object} data 课堂作业
 * @param {String} data.taskName 作业名称
 * @param {String} data.lessonDescribe 作业描述
 * @param {Number} data.totalScore 作业总分
 * @param {Number} data.isGroup 作业类别 0 个人作业  1 小组作业
 * @param {String} data.lessonUid 课堂uid
 */
export const addTask = data => {
    return request(urlPrefix, {
        data
    }, 'post');
};

/**
 * 批量删除作业
 * @param {*} data 
 */
export const removeTask = (data) => {
    return request(`${urlPrefix}/deleteBatch`, {
        data
    }, 'delete');
};

/**
 * 更新课堂作业
 */
export const updateTask = (data) => {
    return request(urlPrefix, {
        data
    }, 'put');
};

/**
 * 
 * @param {Number} page 当前页码
 * @param {Number} limit 每页条目数
 * @param {Object} params 其他参数
 */
export const getTaskList = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit
        }
    });
};

/**
 * 学生查看作业
 * @param {String} uid
 */
export const checkTask = (uid) => {
    return request(`${urlPrefix}/check/${uid}`);
};

/**
 * 学生获取作业详情
 * @param {String} uid
 * @returns {Object} data
 * @return {String} data.uid 学生作业记录UID
 * @return {Number} data.isGroup   0 个人作业  1 小组作业
 * @return {String} data.taskName   作业名称
 * @return {Date} data.cutoffTime   截止日期
 * @return {Array} data.annexs   附件
 * @return {String} data.annexs[].name   附件名称
 * @return {} data.annexs[].size   附件大小
 * @return {} data.annexs[].typeText   附件类型
 * @return {Array} data.logs   操作日志
 * @return {Date} data.annexs[].time   操作时间
 * @return {String} data.annexs[].content   描述
 */
export const detailTask = (uid) => {
    return request(`${urlPrefix}/detail/${uid}`);
};

/**
 * 提交课堂作业
 * @param {*} uid 
 * @param {*} data 
 */
export const reportTask = (uid, data) => {
    return request(`${urlPrefix}/report/${uid}`, {
        data
    }, 'put');
};


/**
 * 删除课堂作业的附件
 * @param {*} uid 
 * @param {*} data 
 */
export const delTaskReport = (uid, data) => {
    return request(`${urlPrefix}/report/${uid}`, {
        data
    }, 'delete');
};

/**
 * 老师获取作业详情
 * @param {*} uid 
 */
export const teacherDetailTask = (uid) => {
    return request(`${urlPrefix}/teacher/detail/${uid}`);
};

/**
 * 教师获取个人作业下的学生完成情况
 * @param {Number} page 当前页码
 * @param {Number} limit 每页条目数
 * @param {String} taskUid 作业UID
 * @param {Number} status 状态 0 未提交，1已提交
 */
export const getTaskStudentList = (params = {}) => {
    return request(`${urlPrefix}/student/tasks`, { params })
}

/**
 * 教师获取小组作业下的学生完成情况
 * @param {Number} page 当前页数
 * @param {Number} limit 每页条目数
 * @param {Object} params 其他参数
 * @param {String} params.taskUid 作业uid
 * @param {Number} params.status 状态,0-未提交,1-已提交
 */
export const getGroupTaskStudentList = (page, limit, params) => {
    return request(`${urlPrefix}/student/group/tasks`, {
        params: {
            ...params,
            page,
            limit
        }
    });
};

/**
 * 教师获取批阅附件列表
 * @param {*} uid 学生/小组作业uid
 */
export const getTaskAnnexList = (uid) => {
    return request(`${urlPrefix}/${uid}/marks`);
};

/**
 * 给学生作业打分
 * @param {String} uid 学生作业记录uid
 * @param {Number} score 分数
 */
export const setTasksScore = (uid, score) => {
    return request(`${urlPrefix}/${uid}/score?score=${score}`, null, 'put');
};

/**
 * 获取当前批阅的个人作业信息
 * @param {String} uid 作业记录uid
 */
export const getMaskTasksInfo = (uid) => {
    return request(`${urlPrefix}/${uid}/mark/info`, null, 'put');
};

/**
 * 获取当前批阅的小组作业信息
 * @param {String} uid 作业记录uid
 */
export const getGroupMaskTasksInfo = (uid) => {
    return request(`${urlPrefix}/${uid}/group/mark/info`, null, 'put');
};

/**
 * 获取学生的作业报告UID
 * @param {*} uid 
 */
export const getMyTask = uid => {
    return request(`${urlPrefix}/mytask`, {
        params: {
            uid
        }
    });
};

/**
 * 获取所有作业
 */
export const getTaskAllList = () => {
    return request(`${urlPrefix}/all` );
};


//通过uid获取作业详情
export const getEntityByUid = uid => {
    return request(`${urlPrefix}/${uid}/detail`);
};

// 课堂作业统计
export const getStatistics = uid => {
    return request(`${urlPrefix}/${uid}/statistics`);
};